import {Component, OnDestroy, OnInit} from '@angular/core';
import {BrowserService} from '../../../shared/services/browser.service';
import {Store} from '@ngrx/store';
import VideoState from '../../../shared/stores/root-store/video.state';
import {
    selectActualVideoState, selectIsInMobilePreviewMode,
    selectResolutionMenuVisibilityFromState,
    selectTimelineVisibilityFromState,
    selectIsIOSFullScreenDisable
} from '../../../shared/stores/root-store/selectors/video.selector';
import {VideoStateEnum} from '../../../../enums/video-state.enum';
import {VideoTimelineVisibilityUpdateAction} from '../../../shared/stores/root-store/actions/timeline.action';
import {Subscription} from 'rxjs';
import {ConfigService} from '../../../shared/services/config.service';
import {ConfigInterface} from '../../../shared/interfaces/configuration.interface';

@Component({
    selector: 'eocm-timeline',
    templateUrl: './timeline.component.html',
    styleUrls: ['./timeline.component.scss']
})
export class TimelineComponent implements OnInit, OnDestroy {
    isTimelineDisabled = true;
    timelineVisibility = false;
    isResolutionMenuVisible = false;
    isInMobilePreviewMode = false;
    subs: Subscription[] = [];
    enableMobileFullscreen: boolean;
    playerConfig: ConfigInterface;

    constructor(
        private browser: BrowserService,
        private config: ConfigService,
        private store: Store<{ video: VideoState }>
    ) {
    }

    ngOnInit() {
        this.playerConfig = this.config.getConfig();
        this.disableTimelineWhenBuffering();
        this.isTimelineVisible();
        this.changeTimelineVisibilityByVideoState();
        this.isResolutionMenuOpen();
        this.subs.push(this.store.select(selectIsInMobilePreviewMode).subscribe((isInMobilePreviewMode) => {
            this.isInMobilePreviewMode = isInMobilePreviewMode;
        }));
        this.store.select(selectIsIOSFullScreenDisable).subscribe(() => {
            this.enableMobileFullscreen = (
                this.browser.isMobileDevice()
                || this.browser.isAppleMobileDevice()
                || this.browser.isAppleDeviceWithIos13plus()
            );
        });
    }

    disableTimelineWhenBuffering() {
        this.store.select(selectActualVideoState).subscribe((currentState) => {
            this.isTimelineDisabled = currentState === VideoStateEnum.Buffering;
        });
    }

    isTimelineVisible() {
        this.store.select(selectTimelineVisibilityFromState).subscribe((currentState) => {
            this.timelineVisibility = currentState;
        });
    }

    changeTimelineVisibilityByVideoState() {
        this.subs.push(this.store.select(selectActualVideoState).subscribe((currentState) => {
            if ([VideoStateEnum.UserPause, VideoStateEnum.Pause].includes(currentState)) {
                this.changeTimelineVisibility(false);
            } else if (currentState === VideoStateEnum.Playing) {
                this.isTimelineDisabled = false;
                this.changeTimelineVisibility(true);
            }
        }));
    }

    isResolutionMenuOpen() {
        this.store.select(selectResolutionMenuVisibilityFromState).subscribe((currentState) => {
            this.isResolutionMenuVisible = currentState;
        });
    }

    changeTimelineVisibility(visibility: boolean) {
        this.store.dispatch(VideoTimelineVisibilityUpdateAction({
            changedVisibility: visibility
        }));
    }

    isFullScreenSupported() {
        return !this.browser.isIphone();
    }

    isDeviceWithVolumeControl() {
        return this.browser.isTabletDevice() || this.browser.isMobileDevice();
    }

    ngOnDestroy(): void {
        this.subs.forEach(sub => {
            sub.unsubscribe();
        });
    }
}
